import { CostArgs } from '../../../../utils'
import { PurchaseBase } from '../../purchase-base'
import { OperationCost } from './operation-cost'
import { PurchaseCost } from './purchase-cost'
import { PurchaseTaxes } from './purchase-taxes'

export * from './expense'

export const Ottawa = {
  purchase: (args: CostArgs) => ({
    ...PurchaseBase,
    costs: PurchaseCost,
    taxes: PurchaseTaxes(args),
  }),
  operation: {
    costs: OperationCost,
  },
} as const
